import React from 'react';
import PropTypes from 'prop-types';

const Waiting = ({ isLoading, children }) => {
    return (
        <>
            {
                isLoading ? <span className="dots-waiting">Waiting</span> : children
            }
        </>
    )
}


Waiting.propTypes = {
     children: PropTypes.node,
     isLoading: PropTypes.bool,
};

export default Waiting;
